// import React, { useEffect, useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Modal,
//   Typography,
//   IconButton,
//   Chip,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// import { TemplateActions } from '../../Services/_actions/Template/template.actions.js';
// import OrganisationDropdown from '../Shared/OrganisationDropdown/index.tsx';
// import BotNumberDropdown from '../Shared/BotNumberDropdown/index.tsx';
// import { TemplateFilters, TemplateResponse } from '../../interfaces/Template.interface.ts';
// import TemplateDropdown from '../Shared/TemplateDropdown/TemplateDropdown.tsx';
// import { useRecoilState } from 'recoil';
// import { templateTableStateAtom } from '../../Services/_states/index.js';
// interface QuickTemplateModalProps {
//   open: boolean;
//   onClose: () => void;
//   onSubmit: (data: any) => void;
//   quickTemplates?: any[];
//   setQuickTemplates?: any
// }

// const QuickTemplateModal: React.FC<QuickTemplateModalProps> = ({
//   open,
//   onClose,
//   onSubmit,
//   quickTemplates = [],
//   setQuickTemplates,
// }) => {
//   const [formData, setFormData] = useState<any>({
//     selectedOrganisation: null,
//     selectedPhoneNumber: null,
//   });
//   const [tableState, setTableState] = useRecoilState(templateTableStateAtom);
//   const templateActions = TemplateActions();
//   const [isTemplateloading, setTemplateIsLoading] = useState(false);
//   const [templateList, setTemplateList] = useState<TemplateResponse>({ pages: 0, list: [{}] });
//   const [templateFilters, setTemplateFilters] = useState<TemplateFilters>({
//     search: '',
//     page: 0,
//     sortOrder: 'desc',
//     sortField: 'created_at',
//     category: '',
//     status: "APPROVED",
//     botNumber: '',
//   });
//   const getTemplateList = async (data) => {
//     setTemplateIsLoading(true);
//     setTemplateFilters({ ...data });
//     try {
//       const res = await templateActions.getWhatsappTemplateList(data);
//       setTemplateList(res);
//     } catch (error) {
//       console.warn('Error fetching template list:', error);
//     } finally {
//       setTemplateIsLoading(false);
//     }
//   };
//   const loadMoreTemplates = async () => {
//     if (templateFilters?.page < templateList?.pages) {
//       setTemplateIsLoading(true);
//       let listData = Array.isArray(templateList?.list) ? [...templateList?.list] : [];
//       const data = { ...templateFilters, search: '', page: templateFilters.page + 1 };
//       setTemplateFilters(data);

//       try {
//         const res = await templateActions.getWhatsappTemplateList(data);
//         if (Array.isArray(res?.list)) {
//           listData = [...listData, ...res.list];
//           setTemplateList({ ...res, list: listData });
//         } else {
//           console.warn('Received non-array response for Template list');
//         }
//       } catch (error) {
//         console.error('Error loading more templates:', error);
//       } finally {
//         setTemplateIsLoading(false);
//       }
//     }
//   };
//   const handleSearchTemplate = (query) => {
//     getTemplateList({ ...templateFilters, search: query || '', page: 0 });
//   };


//   const onSelectOrganisation = async (value) => {
//     setFormData({
//       ...formData,
//       selectedOrganisation: value || null,
//     });
//     const newFilters = {
//       ...tableState?.filters,
//       organisationObj: value || '',
//       organisation: value?.organisation_id || '',
//       page: 0,
//     };
//     setTableState((prev) => ({
//       ...prev,
//       filters: { ...newFilters },
//     }));

//   };


//   const onSelectBusinessNumber = async (e) => {
//     // setTemplateList({ pages: 0, list: [{}] });
//     setFormData({
//       ...formData,
//       selectedPhoneNumber: e || null,
//     });
//     const newFilters = {
//       ...tableState?.filters,
//       botNumber: e?.wa_phone_number || '',
//       channelObj: e,
//       page: 0,
//     };
//     setTableState((prev) => ({
//       ...prev,
//       filters: { ...newFilters },
//     }));

//     // if (e?.wa_phone_number) getTemplateList({ ...templateFilters, botNumber: e?.wa_phone_number, page: 0 });
//   };


//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={{
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         bgcolor: 'background.paper',
//         boxShadow: 24,
//         borderRadius: 2,
//         p: 4,
//         width: 600,
//         maxHeight: '90vh',
//         overflowY: 'auto',
//       }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//           <Typography variant="h6" fontWeight="bold">
//             Add Quick Template
//           </Typography>
//           <IconButton onClick={onClose}><CloseIcon /></IconButton>
//         </Box>
//         <OrganisationDropdown
//           label={
//             <Typography component="span">
//               Organization <span style={{ color: 'red' }}>*</span>
//             </Typography>
//           }
//           value={formData?.selectedOrganisation || null}
//           onChange={(value) => {
//             onSelectOrganisation(value);
//             // setValidationErrors({ ...validationErrors, organisation: '' }); // Clear error for organization
//           }}
//           // error={!!validationErrors?.organisation}
//           // errorMessage={validationErrors?.organisation}
//           sx={{ mb: 1, mt: 2 }}
//         />
//         {formData?.selectedOrganisation?.organisation_id && (
//           <BotNumberDropdown
//             organisation={formData?.selectedOrganisation || null}
//             onChange={(value) => {
//               onSelectBusinessNumber(value);
//               // setValidationErrors({ ...validationErrors, phoneNumber: '' });
//             }}
//             value={formData?.selectedPhoneNumber}
//             label={
//               <Typography component="span">
//                 Phone Number <span style={{ color: 'red' }}>*</span>
//               </Typography>
//             }
//             // error={!!validationErrors?.phoneNumber}
//             // errorMessage={validationErrors?.phoneNumber}
//             sx={{ mb: 1 }}
//           // disabled={false}
//           />
//         )}
//         {formData?.selectedOrganisation?.organisation_id && formData.selectedPhoneNumber &&
//           // <SearchableDropdown
//           //   label="Select Template"
//           //   options={templateList?.list}
//           //   // multiSelect={true}
//           //   value={quickTemplates?.[quickTemplates?.length - 1] || null}
//           //   onSearch={handleSearchTemplate}
//           //   onChange={(value: any) => {
//           //     if (value) {
//           //       setQuickTemplates([...quickTemplates, { name: value?.name, md_id: value?.md_id }]);
//           //     }
//           //   }}
//           //   getOptionLabel={(option) => option?.name}
//           //   fetchMoreOptions={templateList?.has_next ? loadMoreTemplates : undefined}
//           //   loading={isTemplateloading}
//           //   sx={{ marginBottom: 1 }}
//           // />
//           <TemplateDropdown
//             value={quickTemplates?.[quickTemplates?.length - 1] || null}
//             onChange={(value: any) => {
//               if (value) {
//                 setQuickTemplates([...quickTemplates, { name: value?.name, md_id: value?.md_id }]);
//               }
//             }}
//             label="Choose a Template"
//           // organisation={selectedOrganisation} // optional filter by org
//           />

//         }
//         <Box display="flex" flexWrap="wrap" gap={1}>
//           {quickTemplates?.map((item, index) => (
//             <Chip
//               key={index}
//               label={item?.name || ''}
//               onDelete={() => {
//                 const newTemplates = quickTemplates.filter(
//                   (template) => template.md_id !== item.md_id
//                 );
//                 setQuickTemplates(newTemplates);
//               }}
//             />
//           ))}
//         </Box>
//         <Box display="flex" justifyContent="flex-end" mt={2}>
//           <Button onClick={onClose} color="secondary">Cancel</Button>
//           <Button
//             onClick={() => {
//               onSubmit(quickTemplates);
//               onClose();
//             }}
//             color="primary"
//             variant="contained"
//           >
//             Add Selected
//           </Button>
//         </Box>
//       </Box>

//     </Modal>
//   );
// };

// export default QuickTemplateModal;


import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Chip,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OrganisationDropdown from '../Shared/OrganisationDropdown/index.tsx';
import BotNumberDropdown from '../Shared/BotNumberDropdown/index.tsx';
import TemplateDropdown from '../Shared/TemplateDropdown/TemplateDropdown.tsx';
import { useRecoilState } from 'recoil';
import { templateTableStateAtom } from '../../Services/_states/index.js';

interface QuickTemplateModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  quickTemplates?: any[];
  setQuickTemplates?: any;
}

const QuickTemplateModal: React.FC<QuickTemplateModalProps> = ({
  open,
  onClose,
  onSubmit,
  quickTemplates = [],
  setQuickTemplates,
}) => {
  const [formData, setFormData] = useState<any>({
    selectedOrganisation: null,
    selectedPhoneNumber: null,
  });
  const [tableState, setTableState] = useRecoilState(templateTableStateAtom);

  const onSelectOrganisation = async (value) => {
    setFormData((prev) => ({
      ...prev,
      selectedOrganisation: value || null,
    }));
    setTableState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        organisationObj: value || '',
        organisation: value?.organisation_id || '',
        page: 0,
      },
    }));
  };

  const onSelectBusinessNumber = async (value) => {
    setFormData((prev) => ({
      ...prev,
      selectedPhoneNumber: value || null,
    }));
    setTableState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        botNumber: value?.wa_phone_number || '',
        channelObj: value,
        page: 0,
      },
    }));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        p: 4,
        width: {xs:'340px',sm:'600px'},
        maxHeight: '90vh',
        overflowY: 'auto',
      }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            Add Quick Template
          </Typography>
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </Box>

        <OrganisationDropdown
          label={<Typography component="span">Organization <span style={{ color: 'red' }}>*</span></Typography>}
          value={formData?.selectedOrganisation}
          onChange={onSelectOrganisation}
          sx={{ mb: 1, mt: 0, '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-shrink': {
                    top: '-3.5px',
                  }, }}
        />

        {formData?.selectedOrganisation?.organisation_id && (
          <BotNumberDropdown
            organisation={formData?.selectedOrganisation}
            onChange={onSelectBusinessNumber}
            value={formData?.selectedPhoneNumber}
            label={<Typography component="span">Phone Number <span style={{ color: 'red' }}>*</span></Typography>}
            sx={{ mb: 1 , '& .MuiFormLabel-root.MuiInputLabel-shrink': {
                    top: '-3.5px',
                  },
                }}
          />
        )}

        {formData?.selectedOrganisation?.organisation_id && formData.selectedPhoneNumber && (
          <TemplateDropdown
            value={quickTemplates?.[quickTemplates?.length - 1] || null}
            onChange={(value: any) => {
              if (value) {
                setQuickTemplates([...quickTemplates, { name: value?.name, md_id: value?.md_id }]);
              }
            }}
            label="Choose a Template"
            organisation={formData?.selectedOrganisation}
            botNumber={formData?.selectedPhoneNumber?.wa_phone_number}
          />
        )}

        <Box display="flex" flexWrap="wrap" gap={1} sx={{maxHeight:'20vh', overflowY:'auto'}}>
          {quickTemplates?.map((item, index) => (
            <Chip
              key={index}
              label={item?.name || ''}
              onDelete={() => {
                const newTemplates = quickTemplates.filter(
                  (template) => template.md_id !== item.md_id
                );
                setQuickTemplates(newTemplates);
              }}
            />
          ))}
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button onClick={onClose} color="primary">Cancel</Button>
          <Button
            onClick={() => {
              onSubmit(quickTemplates);
              onClose();
            }}
            color="primary"
            variant="contained"
          >
            Add Selected
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuickTemplateModal;







































